import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { cssIsActive } from "@/styles/utils/Utils";
import { colors } from "@/styles/utils/vars";
import { getTypographyBase } from "@/ui/Typography/Typography";
import { StyledList, StyledListItem } from "../List/StyledList";
export const cssSidebarGray = "cssSidebarGray_c1frp7fn";
export const StyledSidebar = /*#__PURE__*/styled('nav')({
  name: "StyledSidebar",
  class: "StyledSidebar_s1k4nu0p"
});
export const SidebarInner = /*#__PURE__*/styled('div')({
  name: "SidebarInner",
  class: "SidebarInner_s1jecfkn"
});

require("./StyledSidebar.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./StyledSidebar.tsx");